export default __webpack_public_path__ + "static/media/business-2.ee7dad62.jpg";